import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/nevada';
import MapSection from '../components/Maps/nevada';

class ThingsToDoInVegasBesidesParty extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Things to Do in Las Vegas Besides Party (Outdoor Adventures)</title>
          <meta name="description" content="Discover the best outdoor things to do in Las Vegas beyond the Strip. From Red Rock Canyon hiking to Valley of Fire and Lake Mead adventures." />
          <meta property="og:title" content="Things to Do in Las Vegas Besides Party" />
          <meta property="og:description" content="Discover the best outdoor things to do in Las Vegas beyond the Strip. From Red Rock Canyon hiking to Valley of Fire and Lake Mead adventures." />
          <meta property="og:url" content="https://exploroff.com/itineraries/things-to-do-in-vegas-besides-party" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/mountain-biking-las-vegas.jpg" />
          <link rel="canonical" href="https://exploroff.com/itineraries/things-to-do-in-vegas-besides-party" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "Things to Do in Las Vegas Besides Party",
            description: "Discover the best outdoor things to do in Las Vegas beyond the Strip.",
            image: ["https://exploroff.com/img/mountain-biking-las-vegas.jpg"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/things-to-do-in-vegas-besides-party" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="Things to Do in Las Vegas Besides Party"
          category="itineraries"
          slug="things-to-do-in-vegas-besides-party"
          excerpt="Red Rock Canyon, Valley of Fire, Lake Mead, and more. Vegas has a wild outdoor side most tourists never see."
          tags={['trail tips', 'planning']}
          readTime={8}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'Red Rock Canyon Area Hotels', type: 'Near Summerlin · Las Vegas', url: 'https://www.booking.com/searchresults.html?ss=Summerlin%2C+Las+Vegas' },
            { name: 'Las Vegas Strip Hotels', type: 'The Strip · Las Vegas, NV', url: 'https://www.booking.com/searchresults.html?ss=Las+Vegas+Strip%2C+Nevada' },
            { name: 'Hotels in Henderson', type: 'Near Lake Mead · Henderson, NV', url: 'https://www.booking.com/searchresults.html?ss=Henderson%2C+Nevada' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default ThingsToDoInVegasBesidesParty;
